import { createRouter, createWebHistory } from "vue-router";
import UserRegistration from "@/userregistration/userregistration.vue";
import UserConfirmation from "@/userregistration/userconfirmation.vue";
import ForgotPassword from "@/userregistration/forgotpassword.vue";
import ResetPassword from "@/userregistration/resetpassword.vue";

import UserManagement from '@/manage/users/addedit.vue';
import UserList from '@/manage/users/list.vue';

const route_prefix = '/vue';

const router = createRouter({
    /*history: createWebHistory(import.meta.env.BASE_URL),*/
    history: createWebHistory(document.getElementsByTagName('base')[0].getAttribute("href")),
    routes: [
        {
            path: route_prefix + '/userregistration',
            name: 'home',
            component: UserRegistration,
            meta: { title: 'User Registration' }
        },
        {
            path:  route_prefix + '/userregistration/confirmation/:id',
            name: 'confirmation',
            component: UserConfirmation,
            props: true,
            meta: { title: 'Registration Confirmation' }
        },
        {
            path:  route_prefix +'/userregistration/forgotpassword',
            name:"forgotpassword",
            component:ForgotPassword,
            meta: { title: 'Forgot Password' }
        },
        {
            path:  route_prefix + '/manage/users',
            name: 'userList',
            component: UserList,
            props: true,
            meta: { title: 'User Management' }
        },
        {
            path:  route_prefix + '/manage/users/:id',
            name: 'userAddEdit',
            component: UserManagement,
            props: true,
            meta: { title: 'Edit User' }
        },
        {
            path: route_prefix + '/userregistration/resetpassword',
            name: 'resetpassword',
            component: ResetPassword,
            meta: { title: 'Reset Password' }
        }
    ],
});

router.afterEach((to) => {
    document.title = (to.meta?.title || 'ShowCase') + ' - ShowCase Web';
});

export default router;
